import React from 'react';
import PropTypes from 'prop-types';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import withAuthentication from 'apex-web/lib/hocs/withAuthentication';
import WalletCardGridContainer from 'apex-web/lib/components/WalletCards/WalletCardGridContainer';
import WalletRowListContainer from 'apex-web/lib/components/WalletRows/WalletRowListContainer';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import NomixInfoIcon from '../images/icons/icon-nomix-info.svg';
import './WalletsPage.css';

const layoutClasses = getBEMClasses('wallets-page');

const detailsLink = '/wallets/product-details';

const WalletsPage = (props, context) => (
  <React.Fragment>
    <div className={layoutClasses('accent-bar')} />
    <div className={layoutClasses('container')}>
      <div className={layoutClasses('banner')}>
        <div className={layoutClasses('banner-title-wrapper')}>
          <img src={NomixInfoIcon} alt="Nomix Info" />
          <div className={layoutClasses('banner-title')}>
            Click on the button to fund your account with fiat
          </div>
        </div>
        <div
          className={layoutClasses('banner-btn')}
          onClick={() => {
            const jwtToken = localStorage.getItem('JWTToken');
            window.open(
              `${
                process.env.REACT_APP_NOMIX_TRANFER_FUNDS_URL
              }?token=${jwtToken}`,
              '_blank'
            );
          }}>
          Fund with fiat
        </div>
      </div>
      <div className={layoutClasses('wallet-list-container-header')}>
        {context.t('Funded Accounts')}
      </div>
      <div className={layoutClasses('wallet-card-container')}>
        <WalletCardGridContainer detailsLink={detailsLink} />
      </div>
      <div className={layoutClasses('wallet-list-container-header')}>
        {context.t('Unfunded Accounts')}
      </div>
      <div className={layoutClasses('wallet-list-container')}>
        <WalletRowListContainer detailsLink={detailsLink} />
      </div>
    </div>
    <div className={layoutClasses('footer')}>
      <PageFooterLayout />
    </div>
  </React.Fragment>
);

WalletsPage.contextTypes = {
  t: PropTypes.func.isRequired
};

export default withAuthentication(WalletsPage);
